<template>
  <div class="page_all">
    <div class="return_link">
      <router-link :to="{ name: 'chargeList', params: { municipality_key: municipalityKey }}">＞ 担当者(課)</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="changeFlg" class="title">担当者(課)の編集</div>
        <div v-else class="title">担当者(課)の追加</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button :disabled="$v.$invalid || this.updating" v-if="changeFlg" class="btn_general" v-on:click="chargeUpdate()">更新</button>
        <button :disabled="$v.$invalid || this.updating" v-else class="btn_general" v-on:click="chargeAdd()">追加</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_regist" colspan="2">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content_top_left">
              <div class="td_index">名前</div>
              <div>
                <input v-model.trim="$v.chargeName.$model" type="text" class="td_charge_name_text"/>
              </div>
              <div class="message">
                <div v-if="$v.chargeName.$dirty">
                  <div class="error" v-if="!$v.chargeName.required">名前は必須入力です。</div>
                  <div class="error" v-if="!$v.chargeName.maxLength">名前は{{ $v.chargeName.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_content_top_right">
              <div class="td_index">メールアドレス</div>
              <div>
                <input v-model.trim="$v.chargeEmail.$model" type="text" class="td_email_text" :disabled="this.changeFlg" />
              </div>
              <div class="message">
                <div v-if="$v.chargeEmail.$dirty">
                  <div class="error" v-if="!$v.chargeEmail.required">メールアドレスは必須入力です。</div>
                  <div class="error" v-if="!$v.chargeEmail.email">不正なメールアドレスです。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle_left">
              <div class="td_content_between">
                <div class="td_index">利用開始日</div>
                <button class="btn_clear" v-on:click="startDateClear()">クリア</button>
              </div>
              <div>
                <datepicker v-model.trim="$v.startDate.$model" :format="DatePickerFormat" :language="ja" class="date_picker" ></datepicker>
              </div>
              <div class="message">
                <div v-if="$v.startDate.$dirty">
                  <div class="error" v-if="!$v.startDate.required">利用開始日は必須入力です。</div>
                  <div class="error" v-if="!$v.startDate.isBefore">利用開始日は利用終了日より以前を入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_content_middle_right">
              <div class="td_index">電話番号</div>
              <div>
                <input v-model.trim="$v.chargeTel.$model" type="text" class="td_tel_no_text"/>
              </div>
              <div class="message">
                <div v-if="$v.chargeTel.$dirty">
                  <div class="error" v-if="!$v.chargeTel.required">電話番号は必須入力です。</div>
                  <div class="error" v-if="!$v.chargeTel.maxLength">電話番号は{{ $v.chargeTel.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <div class="td_content_between">
                <div class="td_index">利用終了日</div>
                <button class="btn_clear" v-on:click="endDateClear()">クリア</button>
              </div>
              <div>
                <datepicker v-model.trim="$v.endDate.$model" :format="DatePickerFormat" :language="ja" class="date_picker"></datepicker>
              </div>
              <div class="message">
                <div v-if="$v.endDate.$dirty">
                  <div class="error" v-if="!$v.endDate.isAfter">利用終了日は利用開始日より以降を入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_content_bottom">
            </td>
          </tr>
        </tbody>
      </table>
      <br/>
      <br/>
      <table>
        <thead>
          <tr>
            <th class="th_authority" colspan="4">権限</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content_authority">
              <label class="label_checkbox">
                <input type="checkbox" v-model="pushAuth" class="check_push" value=""/>Push通知の使用を許可
              </label>
            </td>
            <td class="td_content_authority">
              <label class="label_checkbox">
                <input type="checkbox" v-model="soundAuth" class="check_sound" value=""/>防災通知音の使用を許可
              </label>
            </td>
            <td class="td_content_authority">
            </td>
            <td class="td_content_authority">
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 以下モーダルウィンドウ -->
      <modal v-if="showModal" @close="closeModal">
        <div class="modal_main">
          <table class="tbl_modal">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_comment">名前：{{ chargeName }} を追加しました。</div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_temp_password">
                  <div>
                    仮パスワード： <label id="target_clipcopy">{{ temporaryPassword }}</label>
                  </div>
                  <div>
                    <button class="clipcopy" data-clipboard-target="#target_clipcopy" @click="clipboardCopy">クリップボードにコピー</button>
                  </div>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div></div>
                  <div>
                    <button class="btn_general" @click="closeModal">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ -->
    </div>
  </div>
</template>

<script>
// カレンダー
import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
// モーダルウィンドウ
import modal from '@/components/ChargeModal'
// クリップボードコピー
import clipboard from 'clipboard'
import { required, maxLength, email } from 'vuelidate/lib/validators'

export default {
  components: {
    Datepicker,
    modal
  },
  data: function() {
    return {
      municipalityKey: "",
      chargeName: "",
      chargeEmail: "",
      chargeTel: "",
      startDate: "",
      endDate: "",
      pushAuth: false,
      soundAuth: false,
      // 変更フラグ
      changeFlg: false,
      // 日付入力カレンダー
      ja: ja,
      DatePickerFormat: 'yyyy年MM月dd日',
      // モーダル変数
      showModal: false,
      // 仮パスワード
      temporaryPassword: "",
      // クリップボード
      clipboard: null,
      // エラーメッセージ
      message: "",
      updating: false,
    }
  },
  mounted() {
    // 選択している自治体コード
    this.municipalityKey = this.$store.getters.getStateSelectMunicipalityKey
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // 変更の場合は詳細情報取得
    if (this.changeFlg) {
      this.getChargeTypeDetail()
    }
  },
  methods: {
    async getChargeTypeDetail() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'charge/detail', {
        params: {
          charge_id: this.$store.getters.getStateSelectChargeId
        }
      })
      this.chargeName = response.data[0].charge_name
      this.chargeEmail = response.data[0].charge_email
      this.chargeTel = response.data[0].charge_tel
      this.startDate = response.data[0].start_date
      this.endDate = response.data[0].end_date
      response.data[0].push_auth == 1 ? this.pushAuth = true : this.pushAuth = false
      response.data[0].sound_auth == 1 ? this.soundAuth = true : this.soundAuth = false

      console.log(this.$moment(this.startDate)<this.$moment(this.endDate))
      console.log(this.endDate)
      console.log("test")
    },
    async chargeAdd() {
      this.updating = true;
      // 日付変換
      this.startDate != "" ? this.startDate = this.$moment(this.startDate).format('YYYY-MM-DD') : this.startDate = ""
      this.endDate != "" ? this.endDate = this.$moment(this.endDate).format('YYYY-MM-DD') : this.endDate = ""

      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'charge/add', {
          municipality_key: this.municipalityKey,
          charge_name: this.chargeName,
          charge_email: this.chargeEmail,
          charge_tel: this.chargeTel,
          start_date: this.startDate,
          end_date: this.endDate,
          push_auth: this.pushAuth,
          sound_auth: this.soundAuth,
          admin_user: this.$store.getters.getStateAdminUser
        })
        // 仮パスワード
        this.temporaryPassword = response.data.TemporaryPassword
        this.openModal()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    async chargeUpdate() {
      this.updating = true;
      // 日付変換
      this.startDate != "" ? this.startDate = this.$moment(this.startDate).format('YYYY-MM-DD') : this.startDate = ""
      this.endDate != "" ? this.endDate = this.$moment(this.endDate).format('YYYY-MM-DD') : this.endDate = ""

      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'charge/update', {
          municipality_key: this.municipalityKey,
          charge_id: this.$store.getters.getStateSelectChargeId,
          charge_name: this.chargeName,
          charge_email: this.chargeEmail,
          charge_tel: this.chargeTel,
          start_date: this.startDate,
          end_date: this.endDate,
          push_auth: this.pushAuth,
          sound_auth: this.soundAuth,
          admin_user: this.$store.getters.getStateAdminUser
        })
        this.$router.push({ name: 'chargeList' })
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    openModal: function() {
      this.showModal = true
    },
    closeModal: function() {
      this.showModal = false
      this.$router.push({ name: 'chargeList' })
    },
    clipboardCopy: function() {
      var flag = true
      this.clipboard = new clipboard('.clipcopy')
      this.clipboard.on('success', function(e) {
        if (!flag) {
          return
        }
        alert('クリップボードにコピーしました。')
        e.clearSelection()
        flag = false
      })
    },
		startDateClear: function() {
      if (this.startDate != "") {
        this.startDate = ""
        this.$v.startDate.$touch()
      }
		},
		endDateClear: function() {
			this.endDate = ""
		}
  },
  validations() {
    return {
      chargeName: {
        required,
        maxLength: maxLength(50)
      },
      chargeEmail: {
        required,
        email
      },
      chargeTel: {
        required,
        maxLength: maxLength(255)
      },
      startDate: {
        required,
        isBefore (date) {
          var startdate = this.$moment(date)
          var enddate = this.$moment(this.endDate)

          return startdate.isSameOrBefore(enddate, 'day') || this.endDate == ""
        }
      },
      endDate: {
        isAfter (date) {
          var startdate = this.$moment(this.startDate)
          var enddate = this.$moment(date)

          return enddate.isSameOrAfter(startdate, 'day') || this.endDate == ""
        }
      }
    }
  }
}
</script>

<style scoped>
table tr {
  border: none;
}
table th.th_regist ,th.th_authority{
  text-align: left;
  padding-left: 10px;
}

table td.td_content_top_left {
  text-align: left;
  border: none;
  padding: 20px 10px 0px 20px;
}
table td.td_content_top_right {
  text-align: left;
  border: none;
  padding: 20px 20px 0px 10px;
}

table td.td_content_middle_left {
  text-align: left;
  border: none;
  padding: 0px 10px 0px 20px;
}
table td.td_content_middle_right {
  text-align: left;
  border: none;
  padding: 0px 20px 0px 10px;
}

table td.td_content_bottom {
  text-align: left;
  border: none;
  padding: 0px 10px 0px 20px;
}
table td.td_content_authority {
  text-align: left;
  border: none;
  padding: 20px 0px 20px 20px;
  width: 200px;
}
.td_index {
  padding-bottom: 3px;
}
.td_charge_name_text, .td_email_text, .td_tel_no_text {
  width: 370px;
}
.check_push, .check_sound {
  vertical-align: middle;
  margin-right: 5px;
}

/* モーダル画面 */
.tr_modal {
  border: none;
}
.modal_main {
  width: 480px;
}
.modal_comment {
  text-align: left;
  padding: 20px 0px 5px 20px;
}
.modal_temp_password {
  display: flex;
  justify-content: space-between;
  padding: 5px 5px 20px 20px;
  align-items: center;
}
.tbl_modal {
  width: 480px;
  border: 1px #666666 solid;
  border-collapse: collapse;
  margin: 0 auto;
}
.modal_btn_close {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 0px;
}
.clipcopy {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
}

.td_content_between {
  display: flex;
  justify-content: space-between;
}
.btn_clear {
  background-color: #FFFFFF;
  border: 1px #808080 solid;
  border-radius: 5px;
  color: #808080;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 20px;
  font-size: 11px;
}
</style>